// src/lib/store/app.ts (or your existing store file)
import { create } from "zustand";
import { DEFAULT_LOCALE, type SupportedLocale } from "@/lib/detect-locale";

interface AppState {
  isLanguageLoading: boolean;
  setLanguageLoading: (isLoading: boolean) => void;
  locale: SupportedLocale;
  setLocale: (locale: SupportedLocale) => void;
}

// Seeded with the fixed server-rendered default (not detectLocale(), which
// resolves to the cookie/browser locale on the client) so the client's first
// render matches the server-rendered HTML. useLocaleSync applies the real
// client locale in a post-mount effect.
export const useAppStore = create<AppState>((set) => ({
  isLanguageLoading: false,
  locale: DEFAULT_LOCALE,
  setLanguageLoading: (isLoading) => set({ isLanguageLoading: isLoading }),
  setLocale: (locale) => set({ locale }),
}));
